/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Minecraft account linked yet. Join the server using an official Minecraft client and type /beaconauth link in chat to link your account.`)
};

const zh_hans1_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未绑定 Minecraft 账号。使用正版启动器进入服务器后，在聊天框输入 /beaconauth link 即可获取绑定链接。`)
};

const zh_hant1_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未綁定 Minecraft 帳號。使用正版啟動器進入伺服器後，在聊天框輸入 /beaconauth link 即可獲取綁定連結。`)
};

const fr_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun compte Minecraft lié. Rejoignez le serveur avec un client officiel et exécutez /beaconauth link dans le chat.`)
};

const de_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Minecraft-Konto verknüpft. Treten Sie dem Server mit einem offiziellen Client bei und führen Sie /beaconauth link im Chat aus.`)
};

const ja_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ連携されていません。公式クライアントでサーバーに参加し、チャットで /beaconauth link を実行してください。`)
};

const ko_settings_minecraft_not_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연동된 Minecraft 계정이 없습니다. 공식 클라이언트로 서버에 접속한 뒤 채팅창에 /beaconauth link 명령어를 입력하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_not_linked = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_not_linked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_not_linked", locale)
	if (locale === "en") return en_settings_minecraft_not_linked(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_not_linked(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_not_linked(inputs)
	if (locale === "fr") return fr_settings_minecraft_not_linked(inputs)
	if (locale === "de") return de_settings_minecraft_not_linked(inputs)
	if (locale === "ja") return ja_settings_minecraft_not_linked(inputs)
	return ko_settings_minecraft_not_linked(inputs)
};